import { useEffect, useState } from 'react'
import useFirstRender from '../../hooks/FirstRender';
import LoadMore from '../../components/common/LoadMore';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useApiProgress } from '../../hooks/ApiProgress';
import { ENTITY_IS_IN_USE_MESSAGE, EXCEL_VALIDATION_MESSAGE } from '../../utils/constants';
import readXlsxFile, { readSheetNames } from 'read-excel-file';
import { toast } from 'react-toastify';
import Input from '../../components/Input';
import { AiFillDelete, AiFillEdit } from 'react-icons/ai';
import { formatDate, formatNumber } from '../../utils/functions';
import DeleteModal from '../../components/DeleteModal';
import { pageModel } from '../../utils/model';
import { PAYMENT_PATH, deletePayment, getPagePayments, uploadPaymentExcelFile } from '../../api/paymentApi';
import { translatePaymentMethod, translatePaymentType } from '../../utils/translator';
import { setPaymentSearchParamsAction } from '../../redux/feature/searchParamsSlice';
import Button from '../../components/Button';
import ReceiptModal from '../../components/receipt/ReceiptModal';
import { downloadSupplierReceipts } from '../../api/supplierApi';
import { downloadOutsourcerReceipts } from '../../api/outsourcerApi';
import { downloadCustomerReceipts } from '../../api/customerApi';

const PaymentListPage = ({ title }) => {

    useEffect(() => {
        document.title = "İmperteks / " + title; // Sayfa başlığını güncelle
    }, [title]);

    const isFirstRender = useFirstRender()
    const nav = useNavigate()
    const dispatch = useDispatch()
    const [paymentPage, setPaymentPage] = useState(pageModel)
    const pendingApiCall = useApiProgress('get', `${PAYMENT_PATH}/page`, false)
    const searchParams = useSelector(state => state.searchParams.payment)
    const [searchTimer, setSearchTimer] = useState();
    const pendingApiCallDelete = useApiProgress('delete', `${PAYMENT_PATH}`, false)

    const [isOpen, setIsOpen] = useState(false)
    const [deleteId, setDeleteId] = useState(undefined)

    const [isOpenReceiptModal, setIsOpenReceiptModal] = useState(false)

    const loadPayments = (params) => {
        !pendingApiCall &&
            getPagePayments(params)
                .then(res => {
                    setPaymentPage(prevState => ({ ...res.data, content: [...prevState.content, ...res.data.content] }))
                })
    }

    const onLoadMore = () => {
        if (!paymentPage.last) {
            loadPayments({ ...searchParams, lastId: paymentPage.content[paymentPage.content.length - 1]?.id })
        }
    }

    const searching = async (params) => {
        if (searchTimer) clearTimeout(searchTimer);
        let timer = setTimeout(() => {
            getPagePayments(params)
                .then(res => {
                    setPaymentPage(res.data)
                })
        }, 500);
        setSearchTimer(timer);
    }

    useEffect(() => {
        loadPayments({ size: 20, ...searchParams })
    }, [])

    useEffect(() => {
        !isFirstRender && searching({ ...searchParams })
    }, [searchParams])

    const onClickDelete = () => {
        deletePayment(deleteId)
            .then(res => {
                setIsOpen(false)
                toast.success('Silindi')
                setPaymentPage(prevState => ({ ...prevState, content: prevState.content.filter(p => p.id !== deleteId) }))
                setDeleteId("")
            }).catch(err => {
                toast.error(ENTITY_IS_IN_USE_MESSAGE)
            })
    }

    const uploadExcelFile = async (event) => {
        const file = event.target.files[0];
        if (!Boolean(file)) return;
        const sheets = await readSheetNames(file);
        let rows;
        for (const sheet of sheets) {
            rows = await readXlsxFile(file, { sheet });
            rows.shift();
        }
        const items = []
        for (const row of rows) {
            items.push({
                partnerCode: row[0],
                date: row[1],
                amount: row[2],
                method: row[3],
                type: row[4],
                description: row[5],
                chequeSerialNumber: row[6]
            })
        }
        uploadPaymentExcelFile(items)
            .then(res => {
                toast.success("Kayıtlar güncellendi")
            }).catch(err => {
                toast.error(EXCEL_VALIDATION_MESSAGE)
            })
    }

    const onClickDownloadReceipt = (type, currency) => {
        if (type === 'SUPPLIER') {
            downloadSupplierReceipts(currency)
                .then(res => {
                    const blob = new Blob([res.data], { type: 'application/pdf' })
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = `Tedarikçi Ekstre - ${currency}`;
                    a.click();
                    window.URL.revokeObjectURL(url);
                }).catch(err => {
                    toast.error('Dosya indirilirken hata oluştu!')
                })
        } if (type === 'OUTSOURCER') {
            downloadOutsourcerReceipts(currency)
                .then(res => {
                    const blob = new Blob([res.data], { type: 'application/pdf' })
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = `Fasoncu Ekstre - ${currency}`;
                    a.click();
                    window.URL.revokeObjectURL(url);
                }).catch(err => {
                    toast.error('Dosya indirilirken hata oluştu!')
                })
        }
        if (type === 'CUSTOMER') {
            downloadCustomerReceipts(currency)
                .then(res => {
                    const blob = new Blob([res.data], { type: 'application/pdf' })
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = `Müşteri Ekstre - ${currency}`;
                    a.click();
                    window.URL.revokeObjectURL(url);
                }).catch(err => {
                    toast.error('Dosya indirilirken hata oluştu!')
                })
        }
    }

    return (
        <div>
            <div className='mb-1 border-b border-zinc-300'>
                <label className='text-2xl uppercase'>
                    Ödemeler
                </label>
            </div>
            <div className='flex gap-x-2 py-2 sticky top-0 bg-zinc-50'>
                <Button
                    text='Ekstre'
                    variant='green'
                    onClick={() => setIsOpenReceiptModal(true)}
                />
                {/* <Button
                    text={<label className='flex items-center gap-x-1'><GoPlus />Yeni Ödeme</label>}
                    variant='green'
                    onClick={() => nav('/payment/add')}
                /> */}
            </div>
            {/* <label
                className='bg-emerald-700 hover:bg-emerald-800 disabled:bg-emerald-500 flex items-center gap-x-1 px-2 py-1 text-white text-md rounded-sm'
                htmlFor='excel-upload'
            >
                <RiFileExcel2Fill />
                <span> Excel Yükle</span>
            </label>
            <input className='hidden' id='excel-upload' type='file' accept='.xls, .xlsx' onChange={e => uploadExcelFile(e)} /> */}
            <table className='w-full text-left text-zinc-900 mb-10'>
                <thead className='text-xs uppercase tracking-wide sticky top-2 bg-zinc-50'>
                    <tr>
                        <th className='p-2 w-1/12'>Id</th>
                        <th className='p-2 w-3/12'>İş Ortağı</th>
                        <th className='p-2 w-1/24'>Tarih</th>
                        <th className='p-2 w-1/12'>Miktar</th>
                        <th className='p-2 w-1/12'>Metod</th>
                        <th className='p-2 w-1/12'>Tip</th>
                        <th className='p-2 w-3/12'>Açıklama</th>
                        <th className='p-2 w-1/12'>Aksiyon</th>
                    </tr>
                </thead>
                <tbody>
                    <tr className='border-b items-center sticky top-10 bg-zinc-50 text-sm'>
                        <td className='px-2'>
                            <Input
                                name="id"
                                placeholder='Id...'
                                onChange={e => dispatch(setPaymentSearchParamsAction({ key: e.target.name, value: e.target.value }))}
                                value={searchParams.id}
                            />
                        </td>
                        <td className='px-2'>
                            <Input
                                name="partner"
                                placeholder='İş Ortağı...'
                                onChange={e => dispatch(setPaymentSearchParamsAction({ key: e.target.name, value: e.target.value }))}
                                value={searchParams.partner}
                            />
                        </td>
                        <td className='px-2'>
                            <Input
                                name="paymentDate"
                                type='date'
                                placeholder='Tarih...'
                                onChange={e => dispatch(setPaymentSearchParamsAction({ key: e.target.name, value: e.target.value }))}
                                value={searchParams.paymentDate}
                            />
                        </td>
                        <td className='px-2'>
                            <Input
                                name="amount"
                                type='number'
                                placeholder='Miktar...'
                                onChange={e => dispatch(setPaymentSearchParamsAction({ key: e.target.name, value: e.target.value }))}
                                value={searchParams.amount}
                            />
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                    {
                        paymentPage.content.map((payment, index) => (
                            <tr key={index} className='border-b items-center text-sm'>
                                <td className='p-2'># {payment.id} </td>
                                <td className='p-2'>{payment.supplierName || payment.outsourcerName || payment.customerName}</td>
                                <td className='p-2 '>{formatDate(payment.paymentDate)}</td>
                                <td className='p-2'>{`${formatNumber(payment.amount)} ${payment.currency}`}  </td>
                                <td className='p-2'>{translatePaymentMethod(payment.method)} {payment.chequeSerialNumber ? <span>&rarr; {payment.chequeSerialNumber}</span> : ""}   </td>
                                <td className='p-2'>
                                    <label className={`${payment.type === 'PAYMENT' ? 'bg-red-600' : 'bg-emerald-700'} px-2 py-1 rounded-md text-zinc-100`}> {translatePaymentType(payment.type)} </label>
                                </td>
                                <td className='p-2'>{payment.description} </td>
                                <td className='p-2 items-center'>
                                    <div className='flex gap-x-3'>
                                        <span className='cursor-pointer hover:scale-125 hover:text-blue-600 duration-150' onClick={() => nav(`/payment/edit/${payment.id}`)}>
                                            <AiFillEdit />
                                        </span>
                                        <span
                                            className='cursor-pointer hover:scale-125 hover:text-red-600 duration-150'
                                            onClick={() => {
                                                setIsOpen(true)
                                                setDeleteId(payment.id)
                                            }}
                                        >
                                            <AiFillDelete />
                                        </span>
                                    </div>
                                </td>
                            </tr>
                        ))
                    }
                </tbody>
            </table>
            <LoadMore page={paymentPage} pending={pendingApiCall} onLoadMore={onLoadMore} />
            <DeleteModal
                isOpen={isOpen}
                closeModal={() => setIsOpen(false)}
                onClick={onClickDelete}
                pendingApiCall={pendingApiCallDelete}
            />
            <ReceiptModal
                isOpen={isOpenReceiptModal}
                closeModal={() => setIsOpenReceiptModal(false)}
                onClick={(type, currency) => onClickDownloadReceipt(type, currency)}
            />
        </div>
    )
}

export default PaymentListPage